import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

export async function getSorBrands() {
  const res = await axios.get(`${API_BASE}/sor/brands`, { headers: authHeader() });
  return res.data;
}

export async function getSorBatches(brandId) {
  const res = await axios.get(`${API_BASE}/sor/batches/${brandId}`, { headers: authHeader() });
  return res.data;
}

export async function getSorItems(brandId, startDates) {
  const res = await axios.get(`${API_BASE}/sor/items/${brandId}`, {
    headers: authHeader(),
    params: { start_dates: startDates },
    paramsSerializer: (params) => {
      const sp = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => {
        if (Array.isArray(v)) v.forEach((x) => sp.append(k, x));
        else if (v != null) sp.append(k, v);
      });
      return sp.toString();
    },
  });
  return res.data;
}

export async function sorMarkPaid(itemIds, paidOn) {
  const res = await axios.post(`${API_BASE}/sor/mark-paid`,
    { item_ids: itemIds, paid_on: paidOn }, { headers: authHeader() });
  return res.data;
}
